import { Wishlist } from '../../../features/products/wishlist';

const WishlistPage = () => {
  return (
    <div>
      <Wishlist />
    </div>
  );
};

export { WishlistPage };
